<template>
    <button class="nav-bar-button" :class="{ active: active, red: isRed }" @click="clickInButton">
        <simple-svg 
            v-if="icon" 
            :key="active"
            :src="icon" 
            :custom-class-name="isRed ? 'icon-red' : active ? 'icon-primary' : 'icon'" 
        />
        <!-- <img v-if="icon" :src="icon" alt="icon"> -->
        {{ text }}
    </button>
</template>

<script>
export default {
    name: 'NavBarButton',

    props: {
        text: {
            type: String,
        },
        icon: {
            type: String,
        },
        path: {
            type: String,
        },
        active: {
            type: Boolean,
            default: false
        },
        isRed: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        clickInButton() {
            if (this.path) {
                this.$router.push(this.path)
            }
        }
    }
}
</script>

<style lang="scss">
.nav-bar-button {
    box-sizing: border-box;

    background-color: var(--color-bg);
    border: none;
    border-radius: 10px;
    padding: 5px;
    width: 100%;

    color: var(--color-text);
    text-align: start;
    font-weight: 500;
    font-size: 0.9rem;
    cursor: pointer;

    display: flex;
    align-items: center;
    gap: 10px;

    .icon {
        width: 20px;
        height: 20px;

        path {
            stroke: var(--color-text);
        }

    }

    &.red {
        color: var(--color-red);

        &:hover {
            background-color: color-mix(in srgb, var(--color-red) 10%, transparent);
        }
    }

    &.active {
        position: relative;
        //border-radius: 0 5px 5px 0;

        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            right: -10px;
            width: 3px;
            height: 100%;
            border-radius: 1.5px;
            background-color: var(--color-primary);
        }

        //background-color: var(--color-blue);
    }

    &:hover {
        // overflow: hidden;
        background-color: color-mix(in srgb, var(--color-bg-light) 50%, transparent);
    }

    &:active {
        background-color: var(--color-bg-light);
        color: var(--color-text-dark);
    }
}
</style>
